"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom";
import _ from "underscore";
import Account from "../../api/account";
import AutoConfirmedLoadHeader from "../auto_confirmed_load_header";
import InvoiceInputFields from "./invoice_input_fields";
import LoadAssignerProgress, {
  getLoadAssignerProgressItems
} from "./load_assigner_progress";
import LoadTable from "./load_table";
import LoadSearchArea from "./load_search_area";
import DocumentExceptionArea from "./document_exception_area";
import CarrierChooser from "./carrier_chooser";
import CarrierInvoiceChooser from "./carrier_invoice_chooser";
import DocumentTitle from "../../components/document_title";
import reactUtils from "../../react_utils";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import Auth from "../../util/auth";
var bem = reactUtils.makeBem("document-group-editor");
function hasGuessedLoad(props) {
  return props.loads.guessed.length > 0 || props.loads.selected;
}
function hasInvoices(props) {
  return props.invoicesForGroup.length > 0;
}
function selectedLoadHasCustomerCustomExceptionMessages(props) {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  return ((_e = (_d = (_c = (_b = (_a = props.loads.selectedLoad) == null ? void 0 : _a.load) == null ? void 0 : _b.customer) == null ? void 0 : _c.settings["rules_broker_custom_exception_messages"]) == null ? void 0 : _d.length) != null ? _e : 0) > 0 || ((_j = (_i = (_h = (_g = (_f = props.loads.selectedLoad) == null ? void 0 : _f.load) == null ? void 0 : _g.tms_load_shipments) == null ? void 0 : _h.flatMap(
    (s) => {
      var _a2;
      return (_a2 = s.customer_custom_exception_messages) != null ? _a2 : [];
    }
  )) == null ? void 0 : _i.length) != null ? _j : 0) > 0;
}
function rerouteNidfToException(props) {
  return Auth.getCurrentUser().managed_indexer && Account.preventNidfToLoadWithCustomerCustomExceptionMessagesEnabled() && selectedLoadHasCustomerCustomExceptionMessages(props);
}
function showAssignLoadsContent(props, state) {
  return (!state.showExceptions || state.showExceptions && activeExceptions(props).length > 0) && !state.recentlyResolved;
}
function assignLoadsHeader(props) {
  var selectedLoad = props.loads.selectedLoad;
  var text = "Assign Load to This Document Group";
  if (selectedLoad && !selectedLoad.load.load_is_auto_confirmed) {
    return /* @__PURE__ */ jsx("h3", { children: text });
  } else if (!selectedLoad) {
    return /* @__PURE__ */ jsx("h3", { children: text });
  }
}
function possibleSelectLoadTextNumbering(props) {
  if (props.multiCarrier) {
    return /* @__PURE__ */ jsx("strong", { children: "1." });
  }
}
function autoConfirmedLoadHeader(props) {
  return /* @__PURE__ */ jsx(
    AutoConfirmedLoadHeader,
    {
      carrierInvoice: null,
      load: props.loads.selectedLoad
    }
  );
}
function loadsNotFromEmailCarrier(props, loadState) {
  return props.email.carrier_id && loadState.load.carrier_id !== props.email.carrier_id;
}
function possibleNonMatchingCarrierWarning(props) {
  if (_.find(
    props.loads.guessed,
    (loadState) => loadsNotFromEmailCarrier(props, loadState)
  )) {
    return /* @__PURE__ */ jsx("div", { className: "alert-box--caution", children: /* @__PURE__ */ jsxs("span", { children: [
      "At least one of the following loads is assigned to a",
      " ",
      Account.carrierTermLower(),
      " that does not match the",
      " ",
      Account.carrierTermLower(),
      " assigned to this email."
    ] }) });
  }
}
function carrierChooser(props) {
  if (props.loads.selected && !props.documentBatch.single_carrier) {
    return /* @__PURE__ */ jsxs("div", { className: "load-assigner__carrier-chooser", children: [
      possibleMultipleGuessedCarriersNotification(props),
      /* @__PURE__ */ jsxs("h6", { children: [
        /* @__PURE__ */ jsx("span", { className: "paragraph__possible-select-load-text-numbering", children: /* @__PURE__ */ jsx("strong", { children: "2." }) }),
        " ",
        "Select a ",
        Account.carrierTermLower(),
        " for this group (optional):"
      ] }),
      /* @__PURE__ */ jsx(
        CarrierChooser,
        {
          carrierGuesses: props.carrierGuesses(),
          state: props.carrierChooserState,
          allowIndexingCustomerOnlyDocuments: isIndexCustomerOnlyDocsEnabled(
            props
          ),
          onUpdate: props.onCarrierChooserUpdate
        }
      )
    ] });
  }
}
function guessedLoadsContent(props, state) {
  if (!state.showSearch) {
    return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
      LoadTable,
      {
        items: props.loads.guessed,
        highlightChanged: props.highlightReference,
        selectedLoadStateId: props.loads.selected,
        highlightedLoads: _.pluck(props.loads.guessed, "id"),
        loadsNotFromEmailCarrier: (loadState) => loadsNotFromEmailCarrier(props, loadState),
        onSelectionChange: props.setSelectedLoad
      }
    ) });
  }
}
function possibleMultipleGuessedCarriersNotification(props) {
  if (props.documentGroup.multiple_guessed_carriers) {
    return /* @__PURE__ */ jsxs("div", { className: "alert-box--progress", children: [
      "TriumphPay Audit was unable to automatically assign a",
      " ",
      Account.carrierTermLower(),
      " to this group because multiple different",
      " ",
      Account.carrierTermLower(),
      "s or multiple matching",
      " ",
      Account.carrierTermLower(),
      "s with similar names were detected in the documents."
    ] });
  }
}
function activeExceptions(props, givenProps) {
  const sourceProps = givenProps ? givenProps : props;
  return _.reject(
    sourceProps.documentGroup.exception_events,
    _.property("resolved_at")
  );
}
function isIndexCustomerOnlyDocsEnabled(props) {
  return Account.currentSettings().allow_indexing_customer_only_documents && props.documentBatch.customer_only;
}
function showInvoiceChooserForCustomerOnlyDocs(props) {
  return props.loads.selected && props.assignCustomerOnlyDocuments && isIndexCustomerOnlyDocsEnabled(props);
}
const NO_INVOICE = { id: "none" };
export default class extends React.Component {
  constructor(props) {
    super(props);
    __publicField(this, "invoiceInputFields", () => {
      if (!Account.currentSettings().index_audit_split_enabled) {
        return null;
      }
      const selectedLoad = this.props.loads.selectedLoad;
      let guessedInvoiceAmount = null;
      let guessedInvoiceNumber = null;
      if (selectedLoad) {
        const loadId = selectedLoad.load.load_id;
        const guessedInvoiceData = this.props.documentBatch.guessed_invoice_data_by_load_id[loadId];
        if (guessedInvoiceData) {
          guessedInvoiceAmount = guessedInvoiceData.guessed_invoice_amount;
          guessedInvoiceNumber = guessedInvoiceData.guessed_invoice_number;
        }
      }
      const guessedInvoiceDataFromSubmission = this.props.documentBatch.guessed_invoice_data_from_submission;
      guessedInvoiceAmount != null ? guessedInvoiceAmount : guessedInvoiceAmount = guessedInvoiceDataFromSubmission == null ? void 0 : guessedInvoiceDataFromSubmission.guessed_invoice_amount;
      guessedInvoiceNumber != null ? guessedInvoiceNumber : guessedInvoiceNumber = guessedInvoiceDataFromSubmission == null ? void 0 : guessedInvoiceDataFromSubmission.guessed_invoice_number;
      return /* @__PURE__ */ jsx(
        InvoiceInputFields,
        {
          getSelectedInvoiceForGroup: this.props.getSelectedInvoiceForGroup,
          onFieldChange: this.onInvoiceFieldChange,
          sourceInvoiceAmount: guessedInvoiceAmount,
          sourceInvoiceNumber: guessedInvoiceNumber,
          ref: "invoiceInputFields"
        }
      );
    });
    __publicField(this, "onInvoiceFieldChange", (field, value) => {
      this.setState({ [field]: value });
    });
    __publicField(this, "invoiceDataEntered", () => {
      return !!(this.state.source_invoice_amount && this.state.source_invoice_number);
    });
    __publicField(this, "focusNextField", () => {
      if (this.refs.invoiceInputFields) {
        this.refs.invoiceInputFields.focusNextField();
      }
    });
    __publicField(this, "assignLoad", () => {
      var selectedLoadId = this.props.loads.selected;
      this.setState({ saving: true });
      const carrierID = this.props.selectedCarrierID;
      const carrierInvoice = {};
      ["source_invoice_number", "source_invoice_amount"].forEach((field) => {
        if (this.state[field]) {
          carrierInvoice[field] = this.state[field];
        }
      });
      if (hasInvoices(this.props) && this.props.getSelectedInvoiceForGroup(NO_INVOICE).id !== NO_INVOICE.id) {
        this.props.assignCurrentGroupToLoadAndInvoiceId(
          selectedLoadId,
          this.props.getSelectedInvoiceForGroup(NO_INVOICE).id,
          carrierInvoice,
          carrierID,
          false,
          null
        );
        return;
      }
      if (rerouteNidfToException(this.props)) {
        this.props.exceptionCreator("Custom rules found for this customer", false).then(() => {
          if (!this.props.hasMore) {
            console.log("to dashboard with filters");
            ToDashboardWithFilters(this.props.location);
          } else {
            console.log("documents exception added callback");
            this.props.documentsExceptionAddedCallback();
          }
        });
        return;
      }
      this.props.assignCurrentGroupToLoad(selectedLoadId, carrierID).then(() => this.setState({ saving: false }));
    });
    __publicField(this, "toggleExceptions", () => {
      this.setState({ showExceptions: !this.state.showExceptions });
    });
    __publicField(this, "showSearch", () => {
      this.setState({ showSearch: true });
    });
    __publicField(this, "cancelSearch", () => {
      this.setState({ showSearch: false });
      this.focusNextField();
    });
    __publicField(this, "carrierSelected", (carrier) => {
      this.setState({ carrier });
    });
    __publicField(this, "assignLoadsContent", () => {
      if (showAssignLoadsContent(this.props, this.state)) {
        return /* @__PURE__ */ jsxs("div", { children: [
          assignLoadsHeader(this.props),
          this.selectLoadText(),
          this.documentGroup(),
          this.possibleExceptionsLink()
        ] });
      }
    });
    __publicField(this, "documentGroup", () => {
      return /* @__PURE__ */ jsxs("div", { className: bem("__group"), children: [
        /* @__PURE__ */ jsx("div", { className: bem("__group-title"), children: this.props.group.name }),
        possibleNonMatchingCarrierWarning(this.props),
        this.loadSearchArea(),
        guessedLoadsContent(this.props, this.state)
      ] });
    });
    __publicField(this, "possibleExceptionsLink", () => {
      if (!this.state.showExceptions) {
        return /* @__PURE__ */ jsxs("p", { className: "load-assigner__report-problem", children: [
          "Still issues?",
          " ",
          /* @__PURE__ */ jsx("a", { onClick: this.toggleExceptions, children: "Create an exception" })
        ] });
      }
    });
    __publicField(this, "selectLoadText", () => {
      if (!this.state.showSearch) {
        var selectedLoad = this.props.loads.selectedLoad;
        var text = selectedLoad && selectedLoad.load.load_is_auto_confirmed ? autoConfirmedLoadHeader(this.props) : "Select a load from the loads we identified in the documents. ";
        return /* @__PURE__ */ jsx("p", { className: "paragraph", children: /* @__PURE__ */ jsxs("span", { children: [
          possibleSelectLoadTextNumbering(this.props),
          text,
          "Not the right ones?",
          " ",
          /* @__PURE__ */ jsx("a", { onClick: this.showSearch, children: "Search for another one" }),
          "."
        ] }) });
      }
    });
    __publicField(this, "progressArea", () => {
      if (this.state.tab !== "exception") {
        return /* @__PURE__ */ jsx("div", { className: "load-assigner__save-buttons", children: /* @__PURE__ */ jsxs("div", { className: "load-assigner__save-buttons-inner", children: [
          this.invoiceInputFields(),
          carrierChooser(this.props),
          hasInvoices(this.props) ? this.invoiceChooser() : "",
          this.messageOrSave()
        ] }) });
      }
    });
    __publicField(this, "invoiceChooser", () => {
      if (this.props.selectedCarrierID || showInvoiceChooserForCustomerOnlyDocs(this.props)) {
        return /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(
          CarrierInvoiceChooser,
          {
            loadID: this.props.loads.selectedLoad.load.load_id,
            invoicesForGroup: this.props.invoicesForGroup,
            initialInvoiceId: _.first(
              _.compact(
                _.pluck(this.props.group.documents, "carrier_invoice_id")
              )
            ),
            selectedInvoice: this.props.getSelectedInvoiceForGroup(NO_INVOICE),
            carrierID: this.props.selectedCarrierID,
            group: this.props.group,
            noInvoice: NO_INVOICE,
            currentlyAssignedInvoice: this.props.currentlyAssignedInvoiceForGroup,
            invoiceSelected: this.props.setSelectedInvoiceForGroup
          }
        ) });
      }
    });
    __publicField(this, "messageOrSave", () => {
      let button;
      if (this.state.saving) {
        button = /* @__PURE__ */ jsx("button", { disabled: true, children: "Saving..." });
      } else if (this.props.loads.selected && this.props.selectedCarrierID) {
        let buttonText = "Continue";
        if (rerouteNidfToException(this.props)) {
          buttonText = "Save as Exception";
        } else if (Account.indexAuditSplitEnabled()) {
          buttonText = "Submit";
        }
        button = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("button", { className: "button--progress ", onClick: this.assignLoad, children: buttonText }) });
      } else if (this.props.loads.selected) {
        button = /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs("button", { className: "button--progress ", onClick: this.assignLoad, children: [
          "Continue without selecting ",
          Account.carrierTermLower()
        ] }) });
      } else {
        button = /* @__PURE__ */ jsx("button", { className: "button--disabled", disabled: true, children: "Select a load to continue" });
      }
      const progressItems = getLoadAssignerProgressItems(
        this.props.loads.selectedLoad,
        this.props.documentBatch,
        this.props.documentGroup,
        this.invoiceDataEntered(),
        this.props.shipmentDocumentSelections,
        rerouteNidfToException(this.props),
        this.props.documentLoadRelationships
      );
      return /* @__PURE__ */ jsx("div", { className: bem("__actions"), children: /* @__PURE__ */ jsx(LoadAssignerProgress, { content: button, items: progressItems }) });
    });
    __publicField(this, "recentlyResolved", () => {
      this.setState({ recentlyResolved: true });
    });
    __publicField(this, "closeExceptions", () => {
      this.setState({ recentlyResolved: false, showExceptions: false });
    });
    __publicField(this, "reportProblemContent", () => {
      if (this.state.showExceptions || !this.state.showExceptions && this.state.recentlyResolved) {
        return /* @__PURE__ */ jsx(
          "div",
          {
            className: "load-assigner__document-exception-area panel",
            ref: "problemContent",
            children: /* @__PURE__ */ jsx(
              DocumentExceptionArea,
              {
                closeExceptions: this.closeExceptions,
                location: this.props.location,
                recentlyResolved: this.recentlyResolved,
                hasMore: this.props.hasMore,
                documentsExceptionAddedCallback: this.props.documentsExceptionAddedCallback,
                model: this.props.model,
                email: this.props.email,
                carrier: this.props.carrier,
                selectedLoad: this.props.loads.selectedLoad,
                documentGroup: this.props.documentGroup,
                exceptionResolver: this.props.exceptionResolver,
                exceptionCreator: this.props.exceptionCreator,
                exceptionUpdater: this.props.exceptionUpdater,
                exceptions: activeExceptions(this.props),
                scrollUp: this.scrollUp,
                onCancel: this.toggleExceptions
              }
            )
          }
        );
      }
    });
    __publicField(this, "loadSearchArea", () => {
      if (this.state.showSearch) {
        return /* @__PURE__ */ jsx(
          LoadSearchArea,
          {
            loadsNotFromEmailCarrier: (loadState) => loadsNotFromEmailCarrier(this.props, loadState),
            carrier: this.props.carrier,
            selectedLoadStateId: this.props.loads.selected,
            highlightedLoads: _.pluck(this.props.loads.guessed, "id"),
            searcher: this.props.searcher,
            onSelectionChange: this.props.setSelectedLoad,
            onCancel: this.cancelSearch,
            multiCarrier: this.props.multiCarrier,
            highlightReference: this.props.highlightReference
          }
        );
      }
    });
    __publicField(this, "scrollUp", () => {
      const container = ReactDOM.findDOMNode(this.refs.problemContent);
      container.scrollIntoView();
    });
    const guessedLoad = hasGuessedLoad(props);
    this.state = {
      showExceptions: _.first(activeExceptions(props)),
      showSearch: !guessedLoad,
      showGuessed: guessedLoad,
      source_invoice_amount: null,
      source_invoice_number: null
    };
  }
  componentDidMount() {
    if (hasGuessedLoad(this.props)) {
      this.focusNextField();
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.props.group !== nextProps.group) {
      const guessedLoad = hasGuessedLoad(nextProps);
      this.setState({
        showExceptions: _.first(activeExceptions(this.props, nextProps)),
        showSearch: !guessedLoad,
        showGuessed: guessedLoad
      });
    }
    if (nextProps.saving !== this.props.saving) {
      this.setState({ saving: nextProps.saving });
    }
  }
  // RENDER
  render() {
    return /* @__PURE__ */ jsx(DocumentTitle, { title: "TriumphPay Audit \u2013 Assign Loads", children: /* @__PURE__ */ jsxs("div", { className: "load-assigner__root", ref: "container", children: [
      /* @__PURE__ */ jsxs("div", { className: "load-assigner__scrollable-area", children: [
        this.reportProblemContent(),
        this.assignLoadsContent()
      ] }),
      this.progressArea()
    ] }) });
  }
}
